<template>
  <tbody>
    <tr v-for="(data, index) in seletedData.table[evaluation]" :key="index">
      <td style="text-align: center">
        {{ data.lot ? data.lot.name : '--' }}
      </td>
      <td style="text-align: center">
        {{ data.week_save }}
      </td>
      <template v-for="(values, subcategory) in dataEvaluations">
        <td
          style="vertical-align: sub"
          class="text-left px-3 pb-3 mb-2"
          scope="col"
          v-if="values.containObjetive || values.general"
          :key="subcategory"
        >
          <tag-legend
            v-if="data.containObjetive[subcategory]"
            :avgValue="
              calculateTaskList(
                data.audit_inspection_details,
                subcategory,
                3,
                data.audit_header_with_trashed.discount_percentage
              )
            "
            my="mt-2 my-0"
          />
          <tag-legend
            v-if="data.containObjetive[subcategory]"
            tagType="info"
            :avgValue="
              calculateTaskList(data.audit_inspection_details, subcategory, 2)
            "
            :tagLabel="$t('common_words.correct_answer')"
            class="mb-3"
          />
          <template
            v-for="(value, index) in getSubcategoryGeneral(
              data.audit_inspection_details,
              subcategory
            )"
          >
            <p :key="`${index}-${value}`" class="mb-1" v-if="value">
              <small>{{ value }}</small>
            </p>
          </template>
          <div v-if="data.containObjetive[subcategory]">
            <p
              class="mb-1"
              v-for="(amounts, nameTask) in calculateTaskList(
                data.audit_inspection_details,
                subcategory,
                1
              )"
              :key="nameTask"
            >
              <small
                ><b>{{ amounts.length }}</b>
                {{ $t('common_words.negative_answer')
                }}{{ amounts.length == 1 ? '' : 's' }} {{ $t('table.of') }}
                {{ nameTask }}
              </small>
            </p>
          </div>
        </td>
      </template>
      <td style="vertical-align: sub" scope="col" class="text-center px-3">
        <tag-legend
          :avgValue="
            getGeneralAVG(
              data.audit_inspection_details,
              Object.keys(dataEvaluations),
              data.audit_header_with_trashed.discount_percentage
            )
          "
        />
      </td>
    </tr>
    <slot name="trTotal"></slot>
  </tbody>
</template>
<script>
import MixinMethods from './mixin-methods';
import TagLegend from './TagLegend';

export default {
  name: 'tbody-compliance',
  components: {
    [TagLegend.name]: TagLegend,
  },
  mixins: [MixinMethods],
  props: {
    dataEvaluations: {
      type: Object,
    },
    evaluation: {
      type: String,
    },
    seletedData: {
      type: Object,
    },
  },
};
</script>
